import React from 'react';

import OrganizationsPage from '../components/OrganizationsPage';

const OrganizationsApp = (props) => (
  <OrganizationsPage {...props} />
);

export default OrganizationsApp;
